<template>
  <div style="height: 100%">
    <el-form @submit.native.prevent>
      <el-form-item>
        <el-input
          v-if="filter"
          placeholder="请输入部门关键字"
          clearable
          v-model="filterText"
          size="small"
          suffix-icon="el-icon-search"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="tree-div">
      <el-tree
        ref="deptTree"
        :props="props"
        :data="deptTree"
        show-checkbox
        :node-key="props.key"
        :filter-node-method="filterNode"
        @check-change="checkChangeHandle"
        @check="handleTreeCheck"
        :check-strictly="true">
        <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{node.label}}</span>
        <span v-if="node.childNodes && node.childNodes.length > 0">
          <el-button type="text" size="mini" @click.stop="selectCurrent(node)" >
            <template v-if="node.checked">取消</template>选中（不带下级）
          </el-button>
        </span>
      </span>
      </el-tree>
    </div>

  </div>
</template>
<script>

import DEPT_API from "@/api/api_dept";

export default {
  props:{
    /* 是否提供过滤*/
    filter: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },

  data() {
    return {
      //部门 tree
      deptTree: [],
      //props
      props: {
        children: 'children',
        label: 'text',
        key: 'id'
      },
      //过滤文字
      filterText: undefined,
      selectDataList: [],
      isSelectionIn: false
    }
  },
  methods: {
    selectCurrent(node) {
      console.log(node);
      this.$refs.deptTree.setChecked(node.key, !node.checked)
    },
    //加载部门树
    loadDeptTree() {
      let params = {
        isLookDept: '1',
        showAll: true,
        enable: '0'
      }
      DEPT_API.getTree(params).then((result) => {
        if (result && result.length > 0) {
          this.deptTree = result;
        }
      });
    },
    /*节点过滤*/
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    handleTreeCheck(currentObj, treeStatus) {
      const isChecked = this.$refs.deptTree.getNode(currentObj).checked
      if (isChecked) {
        this.setTreeChildren(currentObj, isChecked)
      } else {
        if (currentObj.children.length > 0) {
          this.setTreeChildren(currentObj, false)
        }
      }
    },
    setTreeParents(currentObj, isChecked) {
      const currentNode = this.$refs.deptTree.getNode(currentObj)
      if (currentNode.parent.key !== undefined) {
        this.$refs.deptTree.setChecked(currentNode.parent.key, isChecked)
        this.setTreeParents(currentNode.parent.key, isChecked)
      }
    },
    setTreeChildren(currentObj, isChecked) {
      this.$refs.deptTree.setChecked(currentObj.id, isChecked)
      currentObj.children.forEach(item => {
        this.setTreeChildren(item, isChecked)
      })
    },
    checkChangeHandle(node, componentInit) {
      this.$nextTick(() => {
        this.selectDataList = [];
        if (this.$refs.deptTree.getCheckedNodes()) {
          this.$refs.deptTree.getCheckedNodes().forEach(obj => {
            let deptName = obj.text;
            if (!deptName.startsWith('「部门」')) {
              deptName  = '「部门」' + deptName;
            }
            this.selectDataList.push({
              key: obj.id,
              label: deptName,
              personType: "1"
            })
          })
        }
        if (!this.isSelectionIn) {
          this.$emit("selection-change", this.selectDataList);
        }
      });
    },
    setSelection(rows) {
      this.isSelectionIn  = true;
      if (this.selectDataList){
        this.$refs.deptTree.setCheckedNodes([]);
      }
      if (rows) {
        let newRows = [];
        rows.forEach(row => {
          newRows.push({
            key: row.key,
            id: row.key,
            label: row.label,
            deptName: row.label
          })
        })
        this.$refs.deptTree.setCheckedNodes(newRows);
      }
      this.isSelectionIn = false;
    },
  },
  watch: {
    filterText(val) {
      this.$refs.deptTree.filter(val);
    }
  },
  mounted() {
    this.loadDeptTree();
  }
}
</script>

<style scoped>
  .tree-div {
    margin-top: 15px;
    height: 355px;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/user/deptSelection.vue